module.exports = __webpack_public_path__ + "assets/pickup-fbd250.svg";